import React, { useState, useEffect } from "react";
import { View, Text, TouchableOpacity, Modal } from "react-native";

import HeaderDefault from "../../components/HeaderDefault";
import RNPickerSelect from "react-native-picker-select"
import ModalSuccess from "../../components/ModalSuccess";
import { LinearGradient } from "expo-linear-gradient";

import styles from "./styles";

const ReportIncome = () => {
    const [itemsYears, setItemsYears] = useState([]);
    const [year, setYear] = useState(0);
    const [modalVisible, setModalVisible] = useState(false);

    useEffect(() => {
        var items = [];
        var initialYear = new Date().getFullYear();
        for (let i = initialYear; i > 1980; i--) {
            items.push({ label: i.toString(), value: i });
        }
        setItemsYears(items);
    }, []);

    return (
        <>
            <HeaderDefault title={"Informe de rendimentos"} />

            <View style={styles.content}>
                {/* <Text style={styles.title}>Selecione o ano</Text> */}

                {/* <RNPickerSelect
                    onValueChange={(value) => setYear(value)}
                    placeholder={{
                        label: 'Selecione um ano',
                        value: 0,
                    }}
                    items={itemsYears}
                    value={year}
                    style={{
                        inputWeb: {
                            borderRadius: 4,
                            paddingHorizontal: 10,
                            height: 40,
                            marginVertical: 10,
                            color: '#222'
                        }
                    }}
                /> */}
                <Text style={{ marginTop: 20, textAlign: 'center', justifyContent: 'center', alignItems: 'center' }}>Você ainda não tem informe de rendimentos.</Text>

            </View>

            {/* <View style={styles.contentBtn}>
                <TouchableOpacity>
                    <LinearGradient
                        start={{ x: -1, y: 0 }}
                        end={{ x: 1, y: 0 }}
                        colors={["#16195B", "#1FBFB5"]}
                        style={styles.btn}
                    >
                        <Text style={styles.textBtn}>BAIXAR</Text>
                    </LinearGradient>
                </TouchableOpacity>
            </View>

            <View style={styles.contentBtnEmail}>
                <TouchableOpacity onPress={() => setModalVisible(!modalVisible)}>
                    <Text style={styles.textBtnEmail}>Enviar por e-mail</Text>
                </TouchableOpacity>
            </View> */}

            <Modal
                animationType="fade"
                transparent={false}
                visible={modalVisible}
                statusBarTranslucent={true}
                onRequestClose={() => setModalVisible((visible) => !visible)}
            >
                <ModalSuccess
                    handleCloseModal={() => {
                        setModalVisible(false);
                    }}
                    text={"Seu documento foi enviado com"}
                    textColor={"sucesso!"}
                    img={2}
                    positionHeader={"left"}
                />
            </Modal>
        </>
    );
}

export default ReportIncome;